import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div` 
  height: 327px;
  width: 490px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.26);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  font-family: ${props => props.theme.fonts.secondary};
  background-color: white;
  margin: 0px 13px 28px 13px;
`
export const CourseName = styled.div` 
  height: 60px;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;
  color: ${props => props.theme.colors.marine};
  margin-top: 15px;
  margin-left: 16px;
  align-self: flex-start;
`
export const Links = styled.div` 
  height: 40px;
  width: 100%;
  border-top: 1px solid #BFBFBF;
  border-bottom: 1px solid #BFBFBF;
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items: center;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: ${props => props.theme.colors.purple};
`
export const LinkText = styled(Link)` 
  margin: 0px 22px;
  color: ${props => props.theme.colors.purple};
`
export const Information = styled.div` 
  flex:1;
  padding-left: 25px;
  padding-right: 25px;
  width: 100%;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.marine};
  align-self: flex-start;

`
export const Text = styled.p` 
  font-weight: ${props => ((props.weight) ? 'bold' : 'normal')};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin: 0;
`
export const Description = styled.p` 
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  margin: 0;
  height: 40px;
  overflow: auto;
`
